import useSWR from 'swr';
import { config } from '@/config';
import { affiliatesService } from '@/services';
import { AwaitedReturnType, FetchErrorsType, IReferralOpportunitiesRequest } from '@/types';
import { useRouter } from '@/hooks/general/useRouter/useRouter';
const API_URL = config.api.url.affiliates;

export const useReferralOpportunities = (params?: IReferralOpportunitiesRequest) => {
    const router = useRouter();
    return useSWR<
        AwaitedReturnType<typeof affiliatesService.referralOpportunities>,
        FetchErrorsType
    >(
        [
            `${API_URL}`,
            params?.campaignId,
            params?.campaignType,
            params?.countryCodes,
            params?.professionIds,
        ],
        () => affiliatesService.referralOpportunities({ ...params }, { routerPush: router.push }),
    );
};

export const useReferralFilters = () => {
    const router = useRouter();
    return useSWR<AwaitedReturnType<typeof affiliatesService.getFilters>, FetchErrorsType>(
        [`${API_URL}`],
        () => affiliatesService.getFilters({ routerPush: router.push }),
    );
};

export const useRedirectInfo = (redirect_jwt: string | undefined, shouldFetch = true) => {
    const router = useRouter();
    return useSWR<AwaitedReturnType<typeof affiliatesService.getRedirectInfo>, FetchErrorsType>(
        shouldFetch && redirect_jwt ? [`${API_URL}/redirect`, redirect_jwt] : null,
        redirect_jwt
            ? () => affiliatesService.getRedirectInfo(redirect_jwt, { routerPush: router.push })
            : null,
    );
};

export const useSurveyLink = (shouldFetch = true) => {
    const router = useRouter();
    return useSWR<AwaitedReturnType<typeof affiliatesService.getSurveyLink>, FetchErrorsType>(
        shouldFetch ? [`${API_URL}/survey-link`] : null,
        () => affiliatesService.getSurveyLink({ routerPush: router.push }),
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            errorRetryCount: 2,
        },
    );
};
